
  <!-- ✅ Full-Width Header -->
   <div class="dialog-header1">
  <div class="dialog-header">
    <h3 class="header-title">{{ data.title }}</h3>
  </div>

  <!-- ✅ Message Section -->
  <div class="dialog-content">
    <p class="message-text">{{ data.message }}</p>
  </div>

  <!-- ✅ Actions (Cancel & Confirm) -->
  <div class="dialog-actions">
    <button (click)="onCancel()" class="cancel-button">No</button>
    <button mat-raised-button color="primary" (click)="onConfirm()" class="submit-button">Yes</button>
  </div></div>

